import { useEffect, useState } from 'react';

import { Button, ButtonProps } from 'farmhub-ui-core';

import { theme } from 'styled';

interface IProps extends ButtonProps {
  src?: any;
  rules?: Array<any>;
  children?: any;
  isMobile?: boolean;
}

const CButton = ({
  children,
  src,
  rules = [],
  loading,
  disabled,
  isMobile,
  ...props
}: IProps): JSX.Element => {
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const handleValidate = () => {
      if (!src || rules.length === 0) {
        return disabled || false;
      }
      let isDisable = false;

      for (let i = 0; i < rules.length; i += 1) {
        const rule = rules[i];
        if (rule.field === 'any' && Object.keys(src).length !== 0) {
          isDisable = false;
          break;
        }

        for (let j = 0; j < rule.conditions.length; j += 1) {
          const condition = rule.conditions[j];
          switch (condition.name) {
            case 'minLength':
              if (
                !src[rule.field] ||
                src[rule.field].length < condition.value
              ) {
                isDisable = true;
              }
              break;

            case 'any':
              if (
                !src[rule.field] ||
                src[rule.field].length < condition.value
              ) {
                isDisable = true;
              }
              break;

            default:
              if (!src[rule.field]) {
                isDisable = true;
              }
              break;
          }
        }
      }
      return isDisable;
    };

    const isDisable = handleValidate();
    setIsDisabled(isDisable);
  }, [src, rules, disabled]);

  return (
    <Button
      disabled={isDisabled}
      height={theme.button.height.md}
      loading={loading}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CButton;
